import type React from "react";
import { ReactComponent as Svg } from "./assets/home-icon.svg";
import * as styles from "./Icon.module.scss";

type HomeProps = React.SVGProps<SVGSVGElement>;

export const Home = ({ className, ...props }: HomeProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
